import { map } from 'lodash'
/* global __ */
let handlers = {
  show: {
    text: '查看',
    async handler (obj, callback) {
      debugger
      let url = `../qualifytpl/index.${__('locale')}.html?id=` + obj.row.value.id + '&edit=false'
      window.open(url)
    }
  }
}
export default function createOptItem (callback) {
  return map(handlers, function (handlerObj, key) {
    // 这里可以统一在handlers里定义
    handlerObj.hidden = function (obj) {
      return false
    }
    handlerObj.callback = callback
    return handlerObj
  })
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/qualiftTplRefer/opt.js